<card class="mb-0">
    <div class="container" *ngIf="!post; else forminfo">
        <form [formGroup]="analysisFormGroup" (ngSubmit)="onSubmit(analysisFormGroup.value)" novalidate>
            <div class="row">
                <div class="col-md-9 my-3">
                    <mat-form-field>
                        <mat-select placeholder="Analysis Type" formControlName="analysisType"
                                    (ngModelChange)="resetAnalysis()" required disableOptionCentering>
                            <mat-option *ngFor="let obj of getDropDownValues('analysisType')" [value]="obj.name">
                                {{obj.desc}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>

        <form [formGroup]="analysisFormGroup_AP" (ngSubmit)="onSubmit(analysisFormGroup_AP.value)" novalidate>
            <div *ngIf="analysisFormGroup.value.analysisType === 'AP'">
                <div class="row">
                    <div class="col-md-9 my-3">
                        <mat-form-field>
                            <mat-label>Regression Type</mat-label>
                            <mat-select formControlName="analysisSubtype">
                                <mat-option value="logistic">4PL + 5PL</mat-option>
                                <mat-option value="mass_spec">Linear + Quadratic</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-9 my-3">
                        <mat-form-field>
                            <input matInput placeholder="Analyte Name" formControlName="analyteName" required
                                   [ngClass]="{ 'is-invalid': formControlsAP.analyteName.errors }">
                            <mat-error *ngIf="analysisFormGroup_AP.controls['analyteName'].errors"
                                       class="invalid-feedback error">
                                <mat-hint [hidden]="!analysisFormGroup_AP.controls['analyteName'].hasError('maxlength')"
                                        align="end">
                                    Exceeds 50 character limit.
                                </mat-hint>
                                <div *ngIf="analysisFormGroup_AP.controls['analyteName'].errors.pattern">
                                    Must be <strong>Alphanumeric</strong>
                                </div>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-9 my-3">
                        <mat-form-field>
                            <input matInput placeholder="Project Code" formControlName="projectCode_AP" required
                                   [ngClass]="{ 'is-invalid': formControlsAP.projectCode_AP.errors }">
                            <mat-error *ngIf="analysisFormGroup_AP.controls['projectCode_AP'].errors"
                                       class="invalid-feedback error">
                                <mat-hint
                                        [hidden]="!analysisFormGroup_AP.controls['projectCode_AP'].hasError('maxlength')"
                                        align="end">
                                    Exceeds 50 character limit.
                                </mat-hint>
                                <div *ngIf="analysisFormGroup_AP.controls['projectCode_AP'].errors.pattern">
                                    Must be <strong>Alphanumeric</strong>
                                </div>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <button *ngIf="analysisFormGroup.value.analysisType=='AP'" class="btn btn-primary m-1 my-5"
                        color="primary" type="submit" [disabled]="!analysisFormGroup_AP.valid">
                    Submit
                </button>
            </div>
        </form>
    </div>

    <ng-template #forminfo>
        <div class="row">
            <div class="col-md-6">
                <strong>Analysis Type:</strong> {{getDisplayString(analysisDetails.analysisType)}}
            </div>
        </div>
        <br>
        <div *ngIf="analysisDetails.analysisType=='AP'">
            <div>
                <div class="col-md-6">
                    <strong>Regression Type:</strong> {{getDisplayString(analysisDetails.analysisSubtype)}}
                </div>
                <div class="col-md-6"><strong>Analyte Name: </strong>{{analysisDetails.analyteName}}</div>
                <div class="col-md-6"><strong>Project Code:</strong> {{analysisDetails.projectCode_AP}}</div>
            </div>
        </div>
        <app-doc-upload [analysisDetails]="analysisDetails"></app-doc-upload>
    </ng-template>
</card>